var exports = {
  "kL": "x8b4e8595--7a115b--container",
  "Kk": "x8b4e8595--7a115b--icon",
  "UU": "x8b4e8595--7a115b--name",
  "vd": "x8b4e8595--7a115b--travel-time",
  "OQ": "x8b4e8595--7a115b--highway-distance",
};

module.exports = exports;
